import { render, staticRenderFns } from "./List-questions.vue?vue&type=template&id=7f2a426a&scoped=true"
import script from "./List-questions.vue?vue&type=script&lang=js"
export * from "./List-questions.vue?vue&type=script&lang=js"
import style0 from "./List-questions.vue?vue&type=style&index=0&id=7f2a426a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2a426a",
  null
  
)

export default component.exports